module.exports = __webpack_public_path__ + "assets/b992b348ffb6453e4a02a60e71c5304e.js";